import axios from 'axios'

const state = {
    fetchPriceListRequest: null,
  priceLists: [],
}

const getters = {
  getPriceLists (state) {
    return state.priceLists
  },
}

const mutations = {
  setPriceLists (state, payload) {
    state.priceLists = payload
  },
}

const actions = {
  fetchPriceLists ({ state, commit, rootGetters }, meta) {
    if (state.fetchPriceListRequest) {
        return state.fetchPriceListRequest
    }

    state.fetchPriceListRequest = axios
      .get(
        rootGetters['api/fetchPriceLists'], {
          params: meta,
        },
      )
      .then((response) => {
        commit('setPriceLists', response.data.items)
        return response
      })

    return state.fetchPriceListRequest
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
